import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  private baseUrl: string;

  constructor(private http: HttpClient, @Optional() @Inject('BASE_API_URL') baseUrl?: string) {
    this.baseUrl = baseUrl ? baseUrl + '' : '';
  }

  /** get prices */
  getPrices(): Observable<any> {
    const url = `${this.baseUrl}subscriptions-public/plans`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        const plans = Array.isArray(resp) ? resp : (Array.isArray(resp?.plans) ? resp.plans : []);
        return { plans };
      })
    );
  }

  /** create subscription */
  buyNow(id, offerId?: string): Observable<any> {
    const url = `${this.baseUrl}subscriptions/create`;
    let payload: any = { planId: id };
    if (offerId) { payload.offerId = offerId; }
    return this.http.post(url, payload);
  }

  /** preview discounted amount for a plan and offer (public) */
  preview(planId: string, offerId: string): Observable<any> {
    const url = `${this.baseUrl}subscriptions-public/preview`;
    return this.http.post(url, { planId, offerId }, { headers: { 'skip-loader': 'true' } });
  }

  paymentValidation(payload): Observable<any> {
    const url = `${this.baseUrl}subscriptions/paid`;
    return this.http.post(url, payload);
  }

  getHomePageArticles(): Observable<any> {
    const url = `https://help.evaltrix.com/api/articles?populate[author][populate][0]=icon&filters[isHomePageArticle][$eq]=true`;
    return this.http.get(url, { headers: { 'skip-loader': 'true' } });
  }

}
